// src/menu/sections/caMenu.ts
import type { AppMenuEntry } from "../types";

export const CA_MENU: AppMenuEntry = {
  type: "group",
  key: "ca",
  label: "CA",
  children: [
    {
      key: "cacontrol",
      label: "X.509 CA Control",
      path: "/cacontrol",
      componentKey: "caControl",
      icon: "siletsencrypt",
    },
    /*
    {
      key: "certificate_automations",
      label: "Certificate Automations",
      path: "/certificate_automations",
      resource: "certificate_automations",
      icon: "ca",
    },
*/
    /*
    {
      key: "automation_credentials",
      label: "Automation Credentials",
      path: "/automation_credentials",
      resource: "automation_credentials",
      icon: "ca",
    },
    {
      key: "automation_jks_credentials",
      label: "JKS Automation Credentials",
      path: "/automation_jks_credentials",
      resource: "automation_jks_credentials",
      icon: "ca",
    },
/*
    {
      key: "certificate_types",
      label: "Certificate Types",
      path: "/certificate_types",
      resource: "certificate_types",
      icon: "ca",
    },
    {
      key: "certificate_authorities",
      label: "CAs (X.509)",
      path: "/certificate_authorities",
      resource: "certificate_authorities",
      icon: "ca",
    },
    {
      key: "ssh_certificate_authorities",
      label: "SSH CAs (SSH)",
      path: "/ssh_certificate_authorities",
      resource: "ssh_certificate_authorities",
      icon: "ca",
    },
    {
      key: "certificates",
      label: "Certificates",
      path: "/certificates",
      resource: "certificates",
      icon: "ca",
    },
*/
    /*
    {
      key: "v_certificate_automations",
      label: "View Certificate Automation",
      path: "/v_certificate_automations",
      resource: "v_certificate_automations",
      icon: "ca",
    },
*/
    /*
    {
      key: "automation_runs",
      label: "Automation Runs",
      path: "/automation_runs",
      resource: "automation_runs",
      icon: "ca",
    },

    {
      key: "automation_target_types",
      label: "Automation Target Types",
      path: "/automation_target_types",
      resource: "automation_target_types",
      icon: "ca",
    },
*/
    {
      key: "crl_entries",
      label: "CRL Entries",
      path: "/crl_entries",
      resource: "crl_entries",
      icon: "table",
    },
    /*
    {
      key: "encryption_config",
      label: "Encryption Config",
      path: "/encryption_config",
      resource: "encryption_config",
      icon: "ca",
    },
    {
      key: "revocation_reasons",
      label: "Revocation Reasons",
      path: "/revocation_reasons",
      resource: "revocation_reasons",
      icon: "ca",
    },
    {
      key: "certificate_statuses",
      label: "Certificate Statuses",
      path: "/certificate_statuses",
      resource: "certificate_statuses",
      icon: "ca",
    },
    {
      key: "issuance_policies",
      label: "Issuance Policies",
      path: "/issuance_policies",
      resource: "issuance_policies",
      icon: "ca",
    },
    {
      key: "caautomationcontrol",
      label: "CA Automation Control",
      path: "/caautomationcontrol",
      componentKey: "caAutomationControl",
      icon: "home",
    },
*/
  ],
};
